import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import withReactRouter from '../hocs/withReactRouter';
import useFlipper from '../../modules/react/hooks/useFlipper';
import { FLIPPER_VOYAGER_HEADER_FOOTER_SETS } from '../../constants/flippers';
import LayoutSectionLoader from '../../src/admin/modules/pageBuilder/components/LayoutSectionLoader';

const GET_PAGE_LAYOUT = gql`
  query getPageLayout($id: ID!) {
    page(id: $id) {
      id
      pageLayout {
        id
        locale {
          code
        }
        pageLayoutType {
          id
        }
        latestVersion {
          id
        }
      }
    }
  }
`;

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const AdminLayoutBuilderButton = ({ location: { pathname }, ...rest }) => {
  const pageId = pathname.split('/').pop();
  const { data, loading } = useQuery(GET_PAGE_LAYOUT, { variables: { id: pageId }, ssr: false });
  const localLayoutsEnabled = useFlipper(FLIPPER_VOYAGER_HEADER_FOOTER_SETS);
  let layoutUrl;

  if (data) {
    const { page: { pageLayout: { pageLayoutType, locale: { code }, latestVersion } } } = data;

    layoutUrl = localLayoutsEnabled
      ? `/admin/locales/${code}/types/${pageLayoutType.id}/page-layout/versions/${latestVersion.id}/edit`
      : `/admin/locales/en-us/types/${pageLayoutType.id}/page-layout/versions/${latestVersion.id}/edit`;
  }

  return <LayoutSectionLoader {...rest} layoutUrl={layoutUrl} disabled={loading} />;
};

AdminLayoutBuilderButton.propTypes = propTypes;
AdminLayoutBuilderButton.defaultProps = defaultProps;

export default withReactRouter(AdminLayoutBuilderButton);
